/**
 * Logger utility for frontend
 * Handles all logging across the application
 */

const LOG_LEVELS = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
};

const isDevelopment = process.env.NODE_ENV === 'development';

const getTimestamp = () => {
  return new Date().toISOString();
};

const formatLog = (level, message, data) => {
  const timestamp = getTimestamp();
  const dataStr = data ? ` | ${JSON.stringify(data)}` : '';
  return `[${timestamp}] [${level}] ${message}${dataStr}`;
};

const log = (level, message, data = null) => {
  const formatted = formatLog(level, message, data);

  // Always log errors
  if (level === LOG_LEVELS.ERROR) {
    console.error(formatted);
  } else if (isDevelopment) {
    // Log other levels only in development
    if (level === LOG_LEVELS.WARN) {
      console.warn(formatted);
    } else if (level === LOG_LEVELS.INFO) {
      console.info(formatted);
    } else {
      console.log(formatted);
    }
  }

  // Store in localStorage for debugging (keep last 100 logs)
  try {
    const logs = JSON.parse(localStorage.getItem('appLogs') || '[]');
    logs.push({ level, timestamp: getTimestamp(), message, data });
    if (logs.length > 100) {
      logs.shift();
    }
    localStorage.setItem('appLogs', JSON.stringify(logs));
  } catch (e) {
    // Fail silently if localStorage is unavailable
  }
};

export const logger = {
  debug: (message, data) => log(LOG_LEVELS.DEBUG, message, data),
  info: (message, data) => log(LOG_LEVELS.INFO, message, data),
  warn: (message, data) => log(LOG_LEVELS.WARN, message, data),
  error: (message, data) => log(LOG_LEVELS.ERROR, message, data),

  // Helper to get all logs from localStorage
  getLogs: () => {
    try {
      return JSON.parse(localStorage.getItem('appLogs') || '[]');
    } catch (e) {
      return [];
    }
  },

  // Helper to clear logs
  clearLogs: () => {
    try {
      localStorage.removeItem('appLogs');
    } catch (e) {
      // Fail silently
    }
  },
};

export default logger;
